import { render, staticRenderFns } from "./FreeApplication.vue?vue&type=template&id=de22245a&scoped=true"
import script from "./FreeApplication.vue?vue&type=script&lang=js"
export * from "./FreeApplication.vue?vue&type=script&lang=js"
import style0 from "./FreeApplication.vue?vue&type=style&index=0&id=de22245a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de22245a",
  null
  
)

export default component.exports